// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_S8d","cls2":"ReferenceEvaluationPage-cls2_a0e ReferenceEvaluationPage-cls1_S8d"};